module.exports = __webpack_public_path__ + "img/MoonSword 5.5c9659e6.png";